import { render, staticRenderFns } from "./port-abroad.vue?vue&type=template&id=36318c0f&scoped=true&"
import script from "./port-abroad.vue?vue&type=script&lang=js&"
export * from "./port-abroad.vue?vue&type=script&lang=js&"
import style0 from "./port-abroad.vue?vue&type=style&index=0&id=36318c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36318c0f",
  null
  
)

export default component.exports